"use strict";
/**
 * Builds the `info` markdown tab shown on the Use Case Details page.
 * Stitches together the AI-use-case overview and the
 * per-section value/list blocks pulled from the draft.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInfoTabMarkdown = exports.buildProcessTimelinePoints = void 0;
var markdown_text_1 = require("./markdown-text");
var field_coercion_1 = require("./field-coercion");
exports.buildProcessTimelinePoints = function (output) {
    var _a;
    var rawProcessValue = field_coercion_1.getOutputFieldValue(output, ['Process']) || ((_a = output === null || output === void 0 ? void 0 : output.Draft) === null || _a === void 0 ? void 0 : _a.Process);
    return markdown_text_1.splitOrderedListValues(rawProcessValue).map(function (description, index) { return ({
        id: "process-" + (index + 1),
        number: index + 1,
        description: description,
    }); });
};
var buildDraftSections = function (output) {
    var draft = output === null || output === void 0 ? void 0 : output.Draft;
    if (!draft) {
        return [];
    }
    return [
        markdown_text_1.toMarkdownValueOrList('Objective', field_coercion_1.getOutputFieldValue(output, ['Objective']) || draft.Objective),
        markdown_text_1.toMarkdownValueOrList('Pain Point', field_coercion_1.getOutputFieldValue(output, ['PainPoint', 'PainPoints']) || draft.PainPoint),
        markdown_text_1.toMarkdownValueOrList('Target Audience', field_coercion_1.getOutputFieldValue(output, ['TargetAudience']) || draft.TargetAudience),
        markdown_text_1.toMarkdownValueOrList('Technology Stack', field_coercion_1.getOutputFieldValue(output, ['TechnologyStack']) || draft.TechnologyStack),
        markdown_text_1.toMarkdownValueOrList('Impact', field_coercion_1.getOutputFieldValue(output, ['Impact']) || draft.Impact),
        markdown_text_1.toMarkdownValueOrList('Risk', field_coercion_1.getOutputFieldValue(output, ['Risk']) || draft.Risk),
        markdown_text_1.toMarkdownValueOrList('Usage', field_coercion_1.getOutputFieldValue(output, ['UsageStats']) || draft.UsageStats),
        markdown_text_1.toMarkdownValueOrList('Time Saving', field_coercion_1.getOutputFieldValue(output, ['TimeSaving']) || draft.TimeSaving),
        markdown_text_1.toMarkdownValueOrList('Other Info', draft.OtherInfo),
    ];
};
/**
 * Build the default info tab markdown from use case and draft fields.
 */
exports.buildInfoTabMarkdown = function (useCase, output, _strategies) {
    var _a, _b;
    var overview = ((_a = output === null || output === void 0 ? void 0 : output.AiUseCase) === null || _a === void 0 ? void 0 : _a.description) ||
        field_coercion_1.getOutputFieldValue(output, ['Objective', 'description']) || ((_b = output === null || output === void 0 ? void 0 : output.Draft) === null || _b === void 0 ? void 0 : _b.Objective) ||
        "" + (useCase.fields.description || '-');
    var sections = ['## Overview', markdown_text_1.normalizeReportText(overview)];
    sections.push.apply(sections, buildDraftSections(output));
    return sections.filter(Boolean).join('\n\n');
};
